module.exports = __webpack_public_path__ + "static/img/logo.ca7cd0e2.png";